module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=CZ - Czech Republic.809a8819.svg";